// extracted by mini-css-extract-plugin
export var background = "_72-0";
export var buttonPrimary = "_72-1";
export var container = "_72-2";
export var containerTopLayerApi = "_72-3";
export var feature = "_72-6";
export var featureBody = "_72-7";
export var featureIcon = "_72-8";
export var featureSummary = "_72-a";
export var featureTitle = "_72-9";
export var modal = "_72-g";
export var modalAction = "_72-f";
export var modalCloseButton = "_72-e";
export var modalFeatures = "_72-5";
export var modalFooter = "_72-b";
export var modalImageLogo = "_72-c";
export var modalLogo = "_72-d";
export var redoModal = "_72-4";